import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import router from '@/modules/router'
import Config from '@/config.loader'

let environment = 'local'
const adminHost = Config.getConfigValue('VUE_APP_ADMIN_PORTAL')

if (adminHost.indexOf('dev.ordit.hu') > -1) {
    environment = 'stage'
}
if (adminHost.indexOf('admin.ordit.') > -1) {
    environment = 'production'
}

Sentry.init({
    Vue: Vue,
    dsn: Config.getConfigValue('VUE_APP_SENTRY_DSN'),
    environment,
    sendDefaultPii: true,
    integrations: [
        // Or omit `router` if you're not using vue-router
        Sentry.browserTracingIntegration({ router }),
    ],
    enableLogs: true,
})
